import { Route } from "vue-router/types";
import { Lang, countryLangMap, getLanguages } from "~/const/locale";

export function getValidLanguageValueList(route: Route) {
  return getLanguages(route?.name).map(item => item.value)
}

export const getPreLang = (route: Route, cookieLangtype: string) => {
  const validLangList = getValidLanguageValueList(route)
  const isValidLang = (lang: string): boolean => validLangList.includes(lang)
  const getValidLang = (lang: string, fallbackLang = countryLangMap.default) => {
    return isValidLang(lang) ? lang : isValidLang(fallbackLang) ? fallbackLang : countryLangMap.default
  }

  if (!route) return getValidLang(cookieLangtype)

  // 1. 最高优先级 - 特殊业务场景
  if (/\/JP\/lp/.test(route.path || '')) { //  /JP/lp1 等页面只有 Japan 语
    return Lang.Japanese;
  }
  if (/ecommerce-new\/uk/.test(route.path || '')) { //  /ecommerce-new/uk只有en-GB
    return Lang.English_United_Kingdom;
  }

  // 2. 第一优先级 - url上的lang参数
  const langFromRouteQuery = route?.query?.lang as string || ''
  if (isValidLang(langFromRouteQuery)) {
    return langFromRouteQuery
  }

  // 3. 第二优先级 - cookie里的lang_type
  if (isValidLang(cookieLangtype)) {
    return cookieLangtype
  }

  // 4. 第三优先级 - route动态参数里的:region参数
  const langFromRouteParams = route.params?.region || ''
  if (isValidLang(langFromRouteParams)) {
    return langFromRouteParams
  }

  // 5. 第四优先级 - 最终默认兜底
  const fallbackLang: string = /\/(jp|ja)/i.test(route.path)
    ? Lang.Japanese
    : countryLangMap.default;
  return getValidLang(fallbackLang);
};
